import React from "react";

export function PageHeader({ eyebrow, title, dot, right, description }) {
  return (
    <div className="px-8 pt-8 pb-5 border-b border-[var(--rw-border)] bg-white sticky top-0 z-30">
      <div className="flex items-start justify-between gap-6 flex-wrap">
        <div>
          <div className="flex items-center gap-2">
            {dot && <span className="nav-dot" style={{ background: dot }} />}
            <div className="label-eyebrow">{eyebrow}</div>
          </div>
          <h1 className="font-display text-3xl font-bold mt-1.5">{title}</h1>
          {description && <p className="text-sm text-neutral-500 mt-1 max-w-2xl">{description}</p>}
        </div>
        {right && <div className="flex items-center gap-2 flex-wrap">{right}</div>}
      </div>
    </div>
  );
}

export function StatCard({ label, value, hint, accent, testid }) {
  return (
    <div className="bg-white border border-[var(--rw-border)] rounded-[4px] p-5" data-testid={testid}>
      <div className="label-eyebrow flex items-center gap-2">
        {accent && <span className="nav-dot" style={{ background: accent }} />}
        {label}
      </div>
      <div className="font-display text-3xl font-bold mt-3 tabular-nums">{value}</div>
      {hint && <div className="text-xs text-neutral-500 mt-1">{hint}</div>}
    </div>
  );
}

export function Section({ title, color, count, defaultOpen = true, children, action }) {
  const [open, setOpen] = React.useState(defaultOpen);
  return (
    <div className="bg-white border border-[var(--rw-border)] rounded-[4px] mb-4 overflow-hidden">
      <div
        className="flex items-center justify-between px-4 py-3 border-b border-[var(--rw-border)] cursor-pointer hover:bg-[var(--rw-surface-2)]"
        onClick={() => setOpen(!open)}
      >
        <div className="flex items-center gap-3">
          <span
            className="w-2.5 h-2.5 rounded-sm"
            style={{ background: color || "#0F1115" }}
          />
          <span className="font-semibold uppercase tracking-[0.07em] text-[12px]">{title}</span>
          {typeof count === "number" && (
            <span className="text-[10px] text-neutral-500 font-mono-rw">{count}</span>
          )}
        </div>
        <div className="flex items-center gap-2" onClick={(e) => e.stopPropagation()}>
          {action}
          <button className="text-neutral-400 text-xs" onClick={() => setOpen(!open)}>
            {open ? "▾" : "▸"}
          </button>
        </div>
      </div>
      {open && <div className="overflow-x-auto">{children}</div>}
    </div>
  );
}

export function rowClass(entry) {
  const s = (entry?.status || "").toLowerCase();
  if (["cancelled", "rescheduled", "no-show", "no show"].includes(s)) return "row-cancelled";
  if (["completed", "closed"].includes(s)) return "row-completed";
  if ((entry?.priority || "").toLowerCase() === "priority") return "row-priority";
  return "";
}

export function StatusPill({ value }) {
  const v = (value || "").toLowerCase();
  let cls = "bg-neutral-100 text-neutral-700 border-neutral-200";
  if (["completed", "closed"].includes(v)) cls = "bg-[#FFF9E5] text-[#7A5900] border-[#FFE9A8]";
  else if (["cancelled", "rescheduled", "no-show", "no show", "lost"].includes(v)) cls = "bg-[#F4F4F4] text-[#666] border-[#E5E5E5]";
  else if (["active", "in progress", "in discussion", "scheduled", "confirmed"].includes(v)) cls = "bg-[#E6F4FF] text-[#0067B8] border-[#BBE0FF]";
  else if (["follow-up needed", "waiting on response", "waiting on client", "waiting on lender"].includes(v)) cls = "bg-[#FFF4E5] text-[#9A5800] border-[#FFE0B2]";
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-[10px] uppercase font-bold tracking-widest border ${cls}`}>
      {value || "—"}
    </span>
  );
}
